import React from "react";
import { useInput } from "react-admin";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { countries } from "../../entities/Countries";
import { useTranslatedInputLabel } from "../../hooks/useTranslatedInputLabel";
import { CountryFlagLabel } from "../CountryFlagLabel";

export const CountryISOCodeInput = (props) => {
    const {
        input: { name, onChange, value },
        meta: { touched, error },
        isRequired,
    } = useInput(props);

    const label = useTranslatedInputLabel(props);
    const selected = countries.find((c) => c.iso2 === value) || null;

    return (
        <Autocomplete
            size="small"
            options={countries}
            getOptionLabel={(o) => o.iso2.toUpperCase()}
            filterOptions={(options, { inputValue }) => {
                const q = inputValue.toLowerCase();
                return options.filter(
                    (o) => o.name.toLowerCase().includes(q) || o.iso2.includes(q)
                );
            }}
            getOptionSelected={(o, v) => o.iso2 === v.iso2}
            value={selected}
            onChange={(_, v) => onChange(v ? v.iso2 : null)}
            renderOption={(o) => <CountryFlagLabel iso={o.iso2} name={o.name} />}
            renderInput={(params) => (
                <TextField
                    {...params}
                    name={name}
                    label={label}
                    variant="filled"
                    fullWidth
                    error={!!(touched && error)}
                    helperText={touched && error}
                    required={isRequired}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: selected ? (
                            <div className={`flag ${selected.iso2}`} style={{ marginRight: 4 }} />
                        ) : null,
                    }}
                />
            )}
        />
    );
};
